import React, { Component } from 'react';
import propTypes from 'prop-types';
import moment from '~/Providers/Moment';
import history from '~/Providers/History';
import Week from './Week';
import { monthEventIndexes } from 'Context/Event';

require('./Month.scss');

export default class Month extends Component {
  constructor() {
    super();
    this.headers = {
      en: [
        { key: 0, tablet: 'Sunday', mobile: 'SUN' },
        { key: 1, tablet: 'Monday', mobile: 'MON' },
        { key: 2, tablet: 'Tuesday', mobile: 'TUES' },
        { key: 3, tablet: 'Wednesday', mobile: 'WED' },
        { key: 4, tablet: 'Thursday', mobile: 'THU' },
        { key: 5, tablet: 'Friday', mobile: 'FRI' },
        { key: 6, tablet: 'Saturday', mobile: 'SAT' },
      ],
      'en-gb': [
        { key: 0, tablet: 'Monday', mobile: 'MON' },
        { key: 1, tablet: 'Tuesday', mobile: 'TUES' },
        { key: 2, tablet: 'Wednesday', mobile: 'WED' },
        { key: 3, tablet: 'Thursday', mobile: 'THU' },
        { key: 4, tablet: 'Friday', mobile: 'FRI' },
        { key: 5, tablet: 'Saturday', mobile: 'SAT' },
        { key: 6, tablet: 'Sunday', mobile: 'SUN' },
      ],
    };
    this.state = {
      allDayEvents: [],
    };
  }

  // Get an array of arrays that represents [week no.][day of month (moment)]
  month = () => {
    const { time } = this.props;
    const day = time.clone().startOf('month');
    const week = Array(7).fill(null);
    const month = [];
    let weekIndex = 0;
    month[0] = [...week];

    const startWeek = day.clone().startOf('week');
    while (startWeek.weekday() < day.weekday()) {
      month[0][startWeek.weekday()] = startWeek.clone();
      startWeek.add(1, 'day');
    }

    [...Array(time.daysInMonth()).keys()].forEach(() => {
      // Initialize the week if we do not have it already. [...] syntax copies the array.
      if (typeof month[weekIndex] === 'undefined') month[weekIndex] = [...week];

      // Assign our day in the month array
      month[weekIndex][day.weekday()] = day.clone();

      day.add(1, 'day');
      if (day.weekday() === 0) weekIndex++;
    });

    const endWeek = time
      .clone()
      .endOf('month')
      .startOf('day');

    while (endWeek.weekday() < 6) {
      endWeek.add(1, 'day');
      month[month.length - 1][endWeek.weekday()] = endWeek.clone();
    }

    return month;
  };

  generateHeader = days => {
    return (
      <div className="flex-row">
        {this.headers[moment.locale()].map((header, key) => {
          if (days[key]) {
            return [
              <div key="a" className="flex-1 tablet month-day-header">
                {header.tablet}
              </div>,
              <div key="b" className="flex-1 mobile month-day-header">
                {header.mobile}
              </div>,
            ];
          }
        })}
      </div>
    );
  };

  componentDidMount = () => {
    this.search = new URLSearchParams(window.location.search);
    this.openLifetimeModal = this.search.get('openLifetimeModal');
    if (this.openLifetimeModal) {
      history.replace('/month');
      history.push('/lifetime');
    }
  };

  componentWillReceiveProps = nextProps => {
    if (
      Object.keys(nextProps.events)
        .length /*&&
            (!isEqual(nextProps.events, this.props.events) ||
                !nextProps.start.isSame(this.props.start)) */
    ) {
      this.setState({
        allDayEvents: monthEventIndexes(
          nextProps.events,
          nextProps.start.clone(),
          nextProps.end.clone(),
          moment.locale()
        ),
      });
    }
  };

  render() {
    const { days, locale, useMondayStart } = this.props;
    console.log(`month render ${locale} ${useMondayStart} `);
    const month = this.month();
    return (
      <div className="month-wrap">
        {this.generateHeader(days)}
        <div
          className={`month-weeks-wrapper ${month.length === 4 &&
            'four-week-month'} ${month.length === 6 && 'six-week-month'}`}
          key={this.props.time.month()}
        >
          {month.map((week, key) => {
            return (
              <Week
                days={days}
                key={key}
                week={week}
                weekNumber={key}
                allDayEvents={this.state.allDayEvents}
                time={this.props.time}
                onDayClick={this.props.onDayClick}
                minDate={this.props.minDate}
              />
            );
          })}
        </div>
      </div>
    );
  }
}

Month.propTypes = {
  days: propTypes.object,
  time: propTypes.object,
  onDayClick: propTypes.func,
  minDate: propTypes.object,
  events: propTypes.object,
  start: propTypes.object,
  end: propTypes.object,
  locale: propTypes.string,
  useMondayStart: propTypes.any,
};
